import ApiClient from '../ApiClient';

class AiBotTransferCasesAPI extends ApiClient {
  constructor(botId) {
    super(`agent_bots/${botId}/transfer_cases`, { accountScoped: true });
  }
}

export default AiBotTransferCasesAPI;
